import React from 'react'
import PropTypes from 'prop-types'

import VagasInput from './vagas_input'
import Gauge from './gauge'
import Mensagens from './mensagens'

export default class Horario extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      vagas_I: props.vagas.internet,
      vagas_L: props.vagas.lote
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    if (e.target.name.match('internet')) {
      this.setState({ vagas_I: parseInt(e.target.value) });
    } else {
      this.setState({ vagas_L: parseInt(e.target.value) });
    }
  }

  lpad_hora() {
    const prefix = (this.props.hora > 9) ? '' : '0'
    return prefix + this.props.hora;
  }

  render () {

    const hora   = this.props.hora;

    const rInter = this.props.reservas.internet;
    const rLote = this.props.reservas.lote;

    const vInter = parseInt(this.state.vagas_I) || 0;
    const vLote = parseInt(this.state.vagas_L) || 0;

    const cap = vInter + vLote;
    const cls = (cap > 0) ? 'text-success' : 'text-secondary';

    const vTot = vInter + vLote;
    const rTot = rInter + rLote;

    return (
        <tr data-hora={hora}>
        <td><b>{this.lpad_hora()}:00</b></td>

        <td className="field td-internet">
          <VagasInput tipo="internet" valor={this.state.vagas_I} handleChange={this.handleChange} />
        </td>
        <td className="right td-internet"><small>{rInter}</small></td>
        <td className="gauge td-internet">
          <Gauge vagas={vInter} reservas={rInter} />
        </td>

        <td className="field td-lotes">
          <VagasInput tipo="lote" valor={this.state.vagas_L} handleChange={this.handleChange} />
        </td>
        <td className="right td-lotes"><small>{rLote}</small></td>
        <td className="gauge td-lotes">
          <Gauge vagas={vLote} reservas={rLote} />
        </td>

        <td className="field td-total">
          <h4 className="capacidade">
            <span className={cls}>{cap}</span>
          </h4>
        </td>
        <td className="right td-total"><small>{ rInter + rLote }</small></td>
        <td className="gauge td-total">
          <Gauge vagas={vTot} reservas={rTot} />
        </td>

        <td>
          <b>{this.lpad_hora()}:00</b>
          <input type="hidden" name="horarios[][hora]" value={hora}></input>
        </td>
        <td>
          <Mensagens vagasI={this.state.vagas_I} vagasL={this.state.vagas_L} gruposPorHora={this.props.gruposPorHora} />
        </td>
      </tr>
    );
  }
}

Horario.propTypes = {
  hora:   PropTypes.number,
  vLote:  PropTypes.number,
  rLote:  PropTypes.number,
  vInter: PropTypes.number,
  rInter: PropTypes.number
};
